const namespace = 'session'

export const SIGN_IN = `${namespace}/SIGN_IN`;
export const SIGN_OUT = `${namespace}/SIGN_OUT`;
